export default __webpack_public_path__ + "media/zurb/img/case-study-cartpros/cartpros-img2-99993cadacebdd4bf1f70915c0cd2587.jpg";